import type { EstimationModel } from 'entities/campaign';
import { formatPrice } from 'shared/lib/formatting';
import type { EstimatorProps } from 'shared/ui/Estimator';
import { Estimator } from 'shared/ui/Estimator';

interface EstimatorToolProps {
  estimations?: EstimationModel;
}

const TOOLTIP_INFO =
  "This amount is calculated from all ZIP Codes' performance in the previous 4 weeks. Bids are not taken into account so data may not be entirely accurate.";

const TITLE = 'Good to know!';

export function EstimationTool({ estimations }: EstimatorToolProps) {
  if (!estimations) {
    return <></>;
  }

  const items: EstimatorProps['items'] = [
    {
      info: 'Average of Bids',
      content: formatPrice(estimations.averageLeadPrice.amount, estimations.averageLeadPrice.currency),
    },
    { info: 'Lead volume range', content: `${estimations.leadsCountRange.min} - ${estimations.leadsCountRange.max}` },
  ];

  return (
    <div className="mb-2">
      <Estimator
        title={TITLE}
        tooltipContent={TOOLTIP_INFO}
        items={items}
      />
    </div>
  );
}
